import { useState } from "react";
import { Btn, Card, Input } from "components/ui/index";
import { supabase } from "supabase";
import { T } from "theme/index";

// ── Login / Register Screen ───────────────────────────────────────────────────
export default function Login() {
  const [mode,     setMode]    = useState("login"); // "login" | "register"
  const [email,    setEmail]   = useState("");
  const [password, setPass]    = useState("");
  const [confirm,  setConfirm] = useState("");
  const [name,     setName]    = useState("");
  const [loading,  setLoading] = useState(false);
  const [err,      setErr]     = useState("");
  const [success,  setSuccess] = useState("");

  const switchMode = (m) => { setMode(m); setErr(""); setSuccess(""); };

  const handleLogin = async () => {
    setLoading(true); setErr("");
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) setErr(error.message === "Invalid login credentials" ? "Email atau password salah." : error.message);
  };

  const handleRegister = async () => {
    if (!name.trim()) return setErr("Nama tidak boleh kosong.");
    if (password.length < 6) return setErr("Password minimal 6 karakter.");
    if (password !== confirm) return setErr("Konfirmasi password tidak cocok.");
    setLoading(true); setErr("");
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: { data: { full_name: name.trim() } },
    });
    setLoading(false);
    if (error) {
      setErr(error.message === "User already registered" ? "Email sudah terdaftar. Silakan masuk." : error.message);
    } else {
      setSuccess("✅ Akun berhasil dibuat! Silakan masuk.");
      setMode("login");
      setPass(""); setConfirm(""); setName("");
    }
  };

  const isLogin = mode === "login";

  return (
    <div style={{ minHeight:"100vh", background:T.bg, display:"flex", alignItems:"center", justifyContent:"center", padding:20, fontFamily:"'DM Sans',sans-serif" }}>
      <div style={{ width:"min(94vw,400px)" }}>

        {/* Logo */}
        <div style={{ textAlign:"center", marginBottom:24 }}>
          <img src="/icon-192.png" alt="JF Finance" style={{ width:72, height:72, borderRadius:18, margin:"0 auto 14px", display:"block" }} />
          <div style={{ color:T.text, fontWeight:800, fontSize:22, letterSpacing:"-0.02em" }}>JF Finance</div>
          <div style={{ color:T.muted, fontSize:12, letterSpacing:"0.1em", marginTop:2 }}>FINANCIAL SOLUTIONS</div>
        </div>

        {/* Mode tabs */}
        <div style={{ display:"flex", background:T.surface, borderRadius:10, padding:4, marginBottom:20, border:`1px solid ${T.border}` }}>
          {[["login","🔓 Masuk"],["register","✨ Daftar"]].map(([m,l]) => (
            <button key={m} onClick={() => switchMode(m)} style={{ flex:1, padding:"9px 0", borderRadius:7, cursor:"pointer", fontWeight:700, fontSize:13, border:"none", background:mode===m?T.card:T.surface, color:mode===m?T.text:T.muted, WebkitTapHighlightColor:"transparent", boxShadow:mode===m?`0 1px 4px rgba(0,0,0,0.3)`:"none" }}>{l}</button>
          ))}
        </div>

        <Card style={{ padding:22 }}>
          {success && (
            <div style={{ background:T.green+"18", border:`1px solid ${T.green}33`, borderRadius:8, padding:"10px 14px", color:T.green, fontSize:13, marginBottom:14 }}>{success}</div>
          )}

          {!isLogin && (
            <Input label="Nama" type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Nama lengkap kamu"
              onKeyDown={e => e.key==="Enter" && handleRegister()} />
          )}

          <Input label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="email@kamu.com"
            onKeyDown={e => e.key==="Enter" && (isLogin ? handleLogin() : handleRegister())} />

          <Input label="Password" type="password" value={password} onChange={e => setPass(e.target.value)}
            placeholder={isLogin ? "••••••••" : "Min. 6 karakter"}
            onKeyDown={e => e.key==="Enter" && (isLogin ? handleLogin() : handleRegister())} />

          {!isLogin && (
            <Input label="Konfirmasi Password" type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Ulangi password"
              onKeyDown={e => e.key==="Enter" && handleRegister()} />
          )}

          {err && <div style={{ color:T.red, fontSize:12, marginBottom:12, marginTop:-4, display:"flex", alignItems:"center", gap:5 }}>⚠️ {err}</div>}

          <Btn
            onClick={isLogin ? handleLogin : handleRegister}
            disabled={loading || !email || !password || (!isLogin && (!confirm || !name))}
            style={{ width:"100%", justifyContent:"center", padding:"12px 0", fontSize:14 }}>
            {loading ? "Memproses..." : isLogin ? "🔓 Masuk" : "✨ Buat Akun"}
          </Btn>
        </Card>

        <div style={{ color:T.muted, fontSize:11, textAlign:"center", marginTop:14, lineHeight:1.7 }}>
          {isLogin ? (
            <>Belum punya akun? <button onClick={() => switchMode("register")} style={{ background:"none", border:"none", color:T.gold, cursor:"pointer", fontSize:11, fontWeight:700, padding:0, WebkitTapHighlightColor:"transparent" }}>Daftar di sini</button></>
          ) : (
            <>Sudah punya akun? <button onClick={() => switchMode("login")} style={{ background:"none", border:"none", color:T.gold, cursor:"pointer", fontSize:11, fontWeight:700, padding:0, WebkitTapHighlightColor:"transparent" }}>Masuk di sini</button></>
          )}
          <br/>Data tersimpan aman & ter-sync di semua device.
        </div>
      </div>
    </div>
  );
}
